<template>
  <div class="registerPage">
    <div class="wrapper" v-if=!validationCode>
      <h1>Subscription</h1>
      <form @submit.stop="submit">
        <div class="form-col">
          <input type="text" v-model="model.username" placeholder="username" />
          <input type="password" v-model="model.password" placeholder="password" />
          <input type="password" v-model="model.repassword" placeholder="Confirm password"/>
        </div>
        <div  class="form-col">
          <select v-model="model.civility" placeholder="civility">
            <option selected value="">Civility</option>
            <option value="mr">Mr.</option>
            <option value="mrs">Mrs.</option>
          </select>
          <input type="text" v-model="model.firstname" placeholder="firstname"/>
          <input type="text" v-model="model.lastname" placeholder="lastname"/>
          <input type="email" v-model="model.email" placeholder="email"/>
          <input type="text" v-model="model.mobile" placeholder="mobile"/>
          <input type="text" v-model="model.phone" placeholder="phone"/>
        </div>
        <button class="btn primary">Submit</button>
      </form>
      <hr />
      <router-link class="link" to="/login">You have already login account ?</router-link>
    </div>
    <div class="wrapper" v-else>
      <h1>Email Confirmation</h1>
      <div v-if="!thanks">
        <p>Please confirm your email by enter the security code you receive by email</p>
        <form @submit.stop="emailValidation">
          <div class="form-col">
            <input type="text" v-model="securityCode" placeholder="security code" />
          </div>
          <button class="btn primary">Submit</button>
        </form>
      </div>
      <div v-else>
        <p>Your email is validated, you can login to your account</p>
        <router-link to="/login" class="btn">Login</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data: () => ({
    model:{
      civility:''
    },
    validationCode:false,
    authKey:null,
    thanks:false,
    securityCode:null,
  }),
  methods:{
    ...mapActions("auth", ["validation"]),
    submit(){
      this.$store.dispatch("auth/register",this.model).then((data) => {
        console.log(data)
        this.validationCode = true
        this.authKey=data.auth_key
      })
    },
    emailValidation(){
      if(this.securityCode && this.authKey){
        this.validation({securityCode: this.securityCode, authKey:this.authKey}).then(() => {
          this.thanks=true
        } )
      }
    }
  }
}
</script>

<style lang="less" >
.registerPage{
  text-align: left;
  max-width: 500px;
  width: 100%;
  background-color: #fff;
  padding: 50px;
  margin: 50px 0;
  p{
    color:#2F2B2B;
    margin-bottom: 2em;
  }
}
</style>